<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">お問い合わせ</span>
              <span class="breadcrumb-link current">お問い合わせ内容の確認</span>
              <span class="breadcrumb-link">お問い合わせ受付の完了</span>
            </div>
            <h1 class="hdg02">お問い合わせ内容の確認</h1>
            <a href="/lc/about/" target="_blank" class="contact-head-link">LEGAL CONNECTIONについて <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
          </div>
          <form @submit.prevent class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">下記内容でお問い合わせを送信いたします。内容をご確認いただき必要があれば「戻る」を押して修正してください。</p>
              <h2 class="hdg03">お問い合わせ内容</h2>
              <ul class="contact-content-list">
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          法人名/個人名 
                        </th>
                        <td>
                          {{ group1.name }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          読み仮名 
                        </th>
                        <td>
                          {{ group1.kana }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          ご担当者名 
                        </th>
                        <td>
                          {{ group1.charge_name }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          ご担当部署名 
                        </th>
                        <td>
                          {{ group1.department }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          郵便番号/住所  
                        </th>
                        <td>
                          〒 {{ group1.postnumber }}<br>
                          {{ group1.address }}{{ group1.address2 }}{{ group1.address3 }}<br>
                          {{ group1.address4 }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          メールアドレス 
                        </th>
                        <td>
                          {{ group1.email }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          職業  
                        </th>
                        <td>
                          {{ group1.selectedOccupationClassificationName }}<br>
                          {{ group1.selectedOccupationName }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          電話番号1 
                        </th>
                        <td>
                          {{ group1.tel }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          電話番号2
                        </th>
                        <td>
                          {{ group1.tel2 }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          内線番号
                        </th>
                        <td>
                          {{ group1.extension }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          FAX番号
                        </th>
                        <td>
                          {{ group1.fax }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          お問い合わせ内容
                        </th>
                        <td>
                          <p class="mb16">{{ group1.message_type }}</p>
                          <p v-html="group1.messageDisp"></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>

              <div class="contact-submit">
                <router-link to="/public/inquiry/index" class="contact-submit-link">
                  <FontawesomeIcon :icon="['fas','angle-left']" class="icn" />
                  戻る
                </router-link>
                <div class="button contact-submit-button">
                  <button class="btn" name="button" @click="group1.onSubmitButtonClicked">送信</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'

import * as logicInquiry from '@/logic/public/Inquiry.js'

export default defineComponent({
  components: {
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicInquiry.getGroupConfirm()

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>

</style>
